import { AboutStory } from '@/components/organisms';

export function AboutPage() {
  return <AboutStory />;
}
